import { Link } from 'react-router-dom'
import { getActiveImage } from '../../lib/characterUtils'
import './CharacterCard.css'

// Placeholder avatar for characters without images
const PLACEHOLDER_AVATAR = 'data:image/svg+xml,' + encodeURIComponent(`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <rect fill="#1E1A22" width="100" height="100"/>
    <circle cx="50" cy="35" r="20" fill="#6E2EBF"/>
    <ellipse cx="50" cy="85" rx="30" ry="25" fill="#6E2EBF"/>
  </svg>
`)

// Generate inline styles for crop positioning
function getCropStyle(crop) {
  if (!crop) return {}

  // x and y are the center point of the crop as percentages (0-100)
  // Use them directly for object-position
  if (crop.x !== undefined && crop.y !== undefined) {
    // Validate values are in reasonable range (0-100)
    const x = Math.max(0, Math.min(100, crop.x))
    const y = Math.max(0, Math.min(100, crop.y))
    return { objectPosition: `${x}% ${y}%` }
  }

  return {}
}

export default function CharacterCard({ character }) {
  const {
    id,
    name,
    class: charClass,
    race,
    title,
    type,
    active,
    deceased
  } = character

  const isInactive = active === false
  const isDeceased = deceased === true

  // Get active image (true form if revealed, otherwise profile)
  const activeImage = getActiveImage(character)
  const cropStyle = getCropStyle(activeImage.crop)

  return (
    <Link to={`/characters/${id}`} className={`character-card ${isInactive ? 'inactive' : ''} ${isDeceased ? 'deceased' : ''}`}>
      <div className="character-avatar">
        <img
          src={activeImage.url || PLACEHOLDER_AVATAR}
          alt={name}
          style={cropStyle}
          onError={(e) => { e.target.src = PLACEHOLDER_AVATAR }}
        />
        {isDeceased && (
          <span className="character-deceased-badge">Deceased</span>
        )}
        {isInactive && !isDeceased && (
          <span className="character-inactive-badge">Inactive</span>
        )}
        <span className={`character-type-badge ${type}`}>
          {type === 'pc' ? 'PC' : 'NPC'}
        </span>
      </div>

      <div className="character-info">
        <h3 className="character-name">{name}</h3>
        {title && <p className="character-title">{title}</p>}
        <p className="character-class">
          {race && `${race} `}{charClass}
        </p>
      </div>
    </Link>
  )
}
